import { DefaultIconProps } from "./default-icon/default-icon-props";
import { DefaultIcon } from "./default-icon/default-icon"

export const PularIcon = (props: DefaultIconProps) => {
    return (
        <>
            <DefaultIcon tipo={props.tipo} class={props.class} style={props.style} fill={props.fill}>
                <path d="M 11 8.15625 L 11 41.84375 L 12.53125 40.84375 L 32 28.15625 L 32 41 L 40 41 L 40 9 L 32 9 L 32 21.84375 L 12.53125 9.15625 Z M 34 11 L 38 11 L 38 39 L 34 39 Z M 13 11.84375 L 32.46875 24.53125 L 33.1875 25 L 32.46875 25.46875 L 13 38.15625 Z"></path>
            </DefaultIcon>
        </>
    );
};

